export default "<style>\r\n\r\n  inline--block,\r\n  .inline--block\r\n  {\r\n    display: inline-block;\r\n  }\r\n\r\n</style>";